import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAccess } from "./AccessGate";

export function SignOutButton() {
  const { user, signOut } = useAccess();
  const who = user?.method === "google" ? user.email : "ingelogd met code";
  return (
    <Button variant="outline" size="icon" className="h-11 w-11 md:h-12 md:w-12 shrink-0 overflow-hidden p-0"
      onClick={signOut} title={`Afmelden (${who})`} aria-label={`Afmelden (${who})`} data-testid="sign-out-button">
      {user?.picture
        ? <img src={user.picture} alt="" referrerPolicy="no-referrer" className="w-full h-full object-cover" data-testid="sign-out-avatar" />
        : <LogOut className="w-5 h-5" />}
    </Button>
  );
}
